import { useFormContext, useForm, FormProvider } from 'react-hook-form';

const ConnectForm = ({ children }) => {
  const methods = useFormContext();

  return children({ ...methods });
};

export { ConnectForm, FormProvider, useForm };
